import { render } from "./Lejar.vue?vue&type=template&id=53be9896"
import script from "./Lejar.vue?vue&type=script&lang=js"
export * from "./Lejar.vue?vue&type=script&lang=js"

import "./Lejar.vue?vue&type=style&index=0&id=53be9896&lang=css"
import "./Lejar.vue?vue&type=style&index=1&id=53be9896&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__